import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import fetchSearchParams from '../../../utils/fetchSearchParams';
import MainLogin from './partials/main-login';
import ForgotPassword from './partials/forgot-password';
import NeedAnAccount from './partials/need-an-account';

type LoginProps = {
  isLoginModal: boolean,
};

interface LocationParams extends URLSearchParams {
  showForgotPass?: string,
}

const Login: React.FC<LoginProps> = (props) => {
  const { isLoginModal } = props;
  const shouldShowForgotPasswordOnLoad = (): boolean => {
    if (isLoginModal) {
      return false;
    }
    const { showForgotPass }: LocationParams = fetchSearchParams();
    return !!showForgotPass;
  };

  const [isLoading, setIsLoading] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(shouldShowForgotPasswordOnLoad());
  const [initialEmail, setInitialEmail] = useState<string | undefined>();

  useEffect(() => {
    if (!isLoginModal) {
      const url: URL = new URL(window.location.href);
      const { showForgotPass }: LocationParams = fetchSearchParams();
      if (showForgotPassword && !showForgotPass) {
        url.searchParams.set('showForgotPass', 'true');
        window.history.pushState({}, '', url.href);
      } else if (!showForgotPassword && showForgotPass) {
        url.searchParams.delete('showForgotPass');
        window.history.pushState({}, '', url.href);
      }
    }
  }, [showForgotPassword, isLoginModal]);

  return (
    <>
      { showForgotPassword && (
        <button
          className="btn-go-back"
          onClick={() => setShowForgotPassword(false)}
        >
          <i className="fa fa-chevron-left" />
          {' '}
          Go back
        </button>
      )}

      <div className="text-center mb-3">
        <img src="/images/logo.png" alt="logo" className="img-fluid logo mb-2" />
      </div>

      <div>
        {!showForgotPassword ? (
          <MainLogin
            onForgotPassword={(email) => {
              setInitialEmail(email);
              setShowForgotPassword(true);
            }}
            setIsLoading={setIsLoading}
          />
        ) : (
          <ForgotPassword
            setIsLoading={setIsLoading}
            initialEmail={initialEmail}
          />
        )}

        <NeedAnAccount
          isLoading={isLoading}
          className="text-center mt-5"
        />
      </div>
    </>
  );
};

export default Login;

document.querySelectorAll('.react-login-component').forEach((element) => {
  const isLoginModal = !!element.closest('#loginModal');
  ReactDOM.render(<Login isLoginModal={isLoginModal} />, element);
});
